import React from "react";
import SystemPage from "pages/Admin/Settings/SystemPage"
import PaymentService from "services/Admin/PaymentService"

const PaymentPage = (props) => {
        return <SystemPage
                Service={PaymentService}
                type={"PaymentTime "}
                meta={"Payment Page "}
                placeholder={"payment"}
                header={"Payments"} payment
                hasSub={false}
        />

}

export default PaymentPage;
